module.exports = __webpack_public_path__ + "static/img/img_4.684c1b15.webp";